import React from 'react';
import { useTheme } from '../theme/theme-context';
import { ThemeMode } from '../theme/types';
import { Button } from './ui/button';

const ICONS: Record<ThemeMode, { label: string; icon: string }> = {
  light: { label: 'Light mode active. Switch to dark mode.', icon: '☀️' },
  dark: { label: 'Dark mode active. Switch to system preference.', icon: '🌙' },
  system: { label: 'System preference active. Switch to light mode.', icon: '🖥️' },
};

export function ThemeToggle(): React.ReactElement {
  const { mode, toggle } = useTheme();
  const { label, icon } = ICONS[mode];

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      }}
      aria-label={label}
      aria-live="polite"
    >
      <span aria-hidden="true">{icon}</span>
    </Button>
  );
}
